import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { OrderModel } from 'src/app/models/preliminaries/order.model';
import { OrderDetailService } from 'src/app/services/preliminaries/order-detail.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-annul-order',
  templateUrl: './annul-order.component.html',
  styleUrls: ['./annul-order.component.scss'],
  standalone: false
})
export class AnnulOrderComponent implements OnInit {

  disable: boolean = false;
  formOrder: FormGroup = new FormGroup({});
  listConcept: any[] = [];
  suscription: Subscription;
  orderId: number = 0;
  orderModel: OrderModel = new OrderModel();

  constructor(private orderService: OrderService,
    private orderDetailService: OrderDetailService,
    private toastHandlerService: ToastHandlerService,
    private formBuilder: FormBuilder,
    public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm(new OrderModel());
    this.getListConcepts();
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.orderId = inputs.orderId;
      this.disable = inputs.disable;
    });
    if (this.disable) {
      setTimeout(() => this.formOrder.disable(), 100);
    }
    await this.getOrderById()
  }

  close(change: boolean) {
    const data: ModalObjectType = {};
    if (change) data.params = { reload: true };
    this.ref.close(data);
  }

  async getListConcepts() {
    try {
      this.listConcept = await firstValueFrom(this.orderService.getAllConcepsForSelectAsync());
    } catch (error) {
      console.error('Error al obetener la lista de conceptos.', error);
    }
  }

  async getOrderById() {
    try {
      this.orderModel = await firstValueFrom(this.orderService.getOrderById(this.orderId));
      this.validateForm(this.orderModel);
    } catch (error) {
      console.error('Error al buscar el pedido.', error);
    }
  }

  async send() {
    Object.keys(this.formOrder.controls).forEach(key => {
      const control = this.formOrder.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formOrder.valid) {
      const modelOrder = this.formOrder.value as OrderModel;
      if (modelOrder.observationAnnul == '') modelOrder.observationAnnul = null;
      this.orderModel.conceptId = modelOrder.conceptId;
      this.orderModel.observationAnnul = modelOrder.observationAnnul;
      try {
        await firstValueFrom(this.orderDetailService.annulOrder(this.orderModel));
        this.close(true);
        this.toastHandlerService.showToast('success', `El pedido fue anulado exitosamente.`, '');
      } catch (error) {
        console.error('Error al anular el pedido.', error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      conceptId: {
        required: 'El campo concepto es obligatorio.',
        min: 'Debes seleccionar un concepto válido.'
      },
      observationAnnul: {
        required: 'El campo observación es obligatorio.',
        maxlength: 'El campo observación permite máximo 250.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formOrder.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  async validateForm(order: OrderModel) {
    this.formOrder = this.formBuilder.group({
      conceptId: [order.conceptId, [Validators.required, Validators.min(1)]],
      observationAnnul: [order.observationAnnul, [Validators.required, Validators.maxLength(250)]]
    });
  }
}
